import React, {useEffect, useState} from "react";
import InitializePage from '../../lib/server/page'
import {LoaderProductList} from '../../lib/server/loaders'
import Productos from '../../components/ProductsListing/ProductsList';


const Product = (props) => {

  return (

      <>
         {props?.data?.productsListing?.products &&
            <Productos pagename={'novedades'} {...props} />
         }
      </>
  );
};

export async function getServerSideProps(context) {    
    return InitializePage(context,LoaderProductList, false)
}

export default Product;
